"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcTableScrollBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_abstract_dropdown_constants_1 = require("../../molecules/bc-dropdown/bc-abstract-dropdown-constants");
var bc_table_base_behavior_1 = require("./bc-table-base-behavior");
var bc_table_constants_1 = require("./bc-table-constants");
var bc_table_constants_2_1 = require("./bc-table-constants-2");
var BcTableScrollBehavior = (function (_super) {
    __extends(BcTableScrollBehavior, _super);
    function BcTableScrollBehavior() {
        var _this = _super.call(this) || this;
        _this.currentFixedColumnIndex = 0;
        _this.stater = 0;
        _this.visibleColumnsId = [];
        _this.settingDropdownBehavior = null;
        _this.columnsVisibiltyStatus = [];
        _this.newFixedColumnId = '';
        _this.settingsDropwdownAlreadyBuild = false;
        setTimeout(function () {
            _this.stater = _this.isSelectionTable ? 1 : 0;
            _this.buildFixedContent();
            _this.setActionColumnListener();
        });
        window.addEventListener(bc_abstract_dropdown_constants_1._DROPDOWN_DISCARDED_EVENT, function (dropdownId) {
            dropdownId.detail === "".concat(_this.tableId, "DropdownSetting") && _this.resetDropdownSetting(dropdownId);
        });
        window.addEventListener(bc_abstract_dropdown_constants_1._DROPDOWN_CLOSED_EVENT, function (dropdownId) {
            dropdownId.detail === "".concat(_this.tableId, "DropdownSetting") && _this.resetDropdownSetting(dropdownId);
        });
        return _this;
    }
    BcTableScrollBehavior.prototype.resetDropdownSetting = function (dropdownId) {
        this.columnsVisibiltyStatus = [];
        this.undoColumnSelection();
        this.resetBodyOverflow(dropdownId);
    };
    BcTableScrollBehavior.prototype.buildFixedContent = function () {
        var _this = this;
        this.mySelf.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_SCROLL_CLASS);
        this.getElements();
        this.getFixedColumnIndex();
        this.setFixedCellClass();
        this.moveTableToDiv();
        if (this.settingDropdownBehavior && this.settingDropdownBehavior.getMySelf() !== null) {
            this.settingDropdownBehavior.getMySelf().remove();
            this.settingDropdownBehavior = null;
        }
        this.buildSettingDropdown();
        this.addEventSettingCheckbox();
        this.addSortEventLeftFixedColumn();
        this.validateHeigthOfCells();
        this.addRezise();
        this.mySelf.addEventListener('change-page', function () {
            var active = _this.mySelf.getElementsByClassName('bc-dropdown-content-active')[0];
            if (active) {
                _this.settingDropdownBehavior.closeDropdown();
            }
        });
    };
    BcTableScrollBehavior.prototype.addRezise = function () {
        var _this = this;
        window.addEventListener('resize', function () {
            _this.validateScroll();
            _this.validateHeigthOfCells();
        });
    };
    BcTableScrollBehavior.prototype.validateHeigthOfCells = function () {
        this.rows.forEach(function (row) {
            var cells = Array.from(row.children);
            var celda = cells.filter(function (cell) { return cell.classList.length == 1 && !cell.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_CELL_CLASS); })[0];
            var fixedCell = cells.filter(function (cell) {
                return cell.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS);
            })[0];
            if (fixedCell) {
                if (fixedCell.clientHeight < celda.clientHeight) {
                    fixedCell.style.height = "".concat(celda.clientHeight, "px");
                }
            }
        });
    };
    BcTableScrollBehavior.prototype.validateScroll = function () {
        var table = this.mySelf.getElementsByClassName(bc_table_constants_1.BcTableConstansts.TABLE_CONTENT_CLASS)[0];
        var contentTable = this.mySelf.getElementsByTagName('table')[0];
        var fixedCells = this.mySelf.getElementsByClassName(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS);
        var validateWidth = contentTable.offsetWidth - table.offsetWidth > 0;
        for (var i = 0; i < fixedCells.length; i++) {
            if (validateWidth) {
                fixedCells[i].classList.add(bc_table_constants_1.BcTableConstansts.TABLE_SHADOW_CLASS);
                fixedCells[i].classList.add(bc_table_constants_1.BcTableConstansts.TABLE_BORDER_CLASS);
            }
            else {
                fixedCells[i].classList.remove(bc_table_constants_1.BcTableConstansts.TABLE_SHADOW_CLASS);
                fixedCells[i].classList.remove(bc_table_constants_1.BcTableConstansts.TABLE_BORDER_CLASS);
            }
        }
    };
    BcTableScrollBehavior.prototype.getFixedColumnIndex = function () {
        var index = this.isSelectionTable ? 1 : 0;
        for (var i = 0; i < this.columns.length; i++) {
            var column = this.columns[i];
            if (column.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_CLASS)) {
                index = i;
            }
        }
        if (index <= 1 && !this.columns[index].classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_CLASS)) {
            this.columns[index].classList.add(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_CLASS);
        }
        this.currentFixedColumnIndex = index;
    };
    BcTableScrollBehavior.prototype.addSortEventLeftFixedColumn = function () {
        var _this = this;
        var fixedColumnLeft = this.mySelf.querySelector("".concat(common_constants_1.BcCommonConstants.TH_TAG, ".").concat(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS));
        var tbody = this.table.querySelector(common_constants_1.BcCommonConstants.TBODY_TAG);
        this.asc = !this.asc;
        fixedColumnLeft.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            var icon = fixedColumnLeft.querySelector(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_SORT_ICON_CLASS));
            if (icon) {
                icon.remove();
            }
            _this.columnSortEvent(fixedColumnLeft, tbody);
        });
    };
    BcTableScrollBehavior.prototype.setFixedCellClass = function () {
        var actionColumn = this.rows[0].children[this.rows[0].children.length - 1];
        actionColumn !== null && actionColumn.classList.add("".concat(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_ACTION_CELL_CLASS));
        for (var i = 1; i < this.rows.length; i++) {
            var row = this.rows[i];
            var lastChild = row.children[row.children.length - 1];
            var fixedCell = row.children[this.currentFixedColumnIndex];
            fixedCell.classList.add("".concat(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_CELL_CLASS));
            var isAction = lastChild.classList.contains("".concat(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_CELL_CLASS));
            var hasDropdown = lastChild.querySelector('.bc-dropdown');
            if (isAction && hasDropdown) {
                lastChild.classList.add("".concat(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_ACTION_CELL_CLASS));
            }
            var isActionInline = lastChild.classList.contains("".concat(bc_table_constants_1.BcTableConstansts.TABLE_CELL_ACTION_INLINE_CLASS));
            var hasBtn = lastChild.querySelector('.bc-button-icon');
            if (isActionInline && hasBtn) {
                lastChild.classList.add("".concat(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_ACTION_CELL_CLASS));
            }
        }
        this.createFixedLeftColumn();
    };
    BcTableScrollBehavior.prototype.moveTableToDiv = function () {
        var content = this.mySelf.querySelector(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_CONTENT_CLASS));
        var subcontainer = this.mySelf.querySelector(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_SUBCONTAINER));
        if (!subcontainer) {
            subcontainer = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
            subcontainer.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_SUBCONTAINER);
        }
        subcontainer.appendChild(this.table);
        content.appendChild(subcontainer);
    };
    BcTableScrollBehavior.prototype.createFixedLeftColumn = function () {
        var _a;
        var masterCheckbox = null;
        var validateLeftColumn = document.getElementsByClassName(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS);
        if (validateLeftColumn.length > 1) {
            this.resetFixedColumn(false);
        }
        for (var i = 0; i < this.rows.length; i++) {
            var row = this.rows[i];
            var fixedCell = row.querySelector(".".concat(i === 0 ? bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_CLASS : bc_table_constants_1.BcTableConstansts.TABLE_FIXED_CELL_CLASS));
            if (fixedCell !== null) {
                if (fixedCell.querySelector("[class~='bc-sort-icon-hover']")) {
                    (_a = fixedCell.querySelector("[class~='bc-sort-icon-hover']")) === null || _a === void 0 ? void 0 : _a.remove();
                }
            }
            else {
                break;
            }
            var newFixedCell = this.createCellByType(i);
            if (this.isSelectionTable) {
                this.handleSelectionTable(row, newFixedCell, masterCheckbox, fixedCell);
            }
            else {
                this.copyFixedCellClasses(fixedCell, newFixedCell);
            }
            row.insertBefore(newFixedCell, row.firstChild);
        }
        this.validateScroll();
        this.validateCellsWithHeader();
    };
    BcTableScrollBehavior.prototype.validateCellsWithHeader = function () {
        for (var j = 1; j < this.rows.length; j++) {
            var cells = this.rows[j].children;
            for (var i = 1; i < cells.length - 1; i++) {
                if (!cells[i].classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS) &&
                    this.columns[i - 1].classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS)) {
                    cells[i].classList.add(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS);
                }
                else if (cells[i].classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS) &&
                    !this.columns[i - 1].classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS)) {
                    cells[i].classList.remove(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS);
                }
            }
        }
    };
    BcTableScrollBehavior.prototype.createCellByType = function (index) {
        var fixedTD = document.createElement(index === 0 ? bc_table_constants_1.BcTableConstansts.TABLE_TH_CLASS : bc_table_constants_1.BcTableConstansts.TABLE_TD_CLASS);
        fixedTD.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS);
        return fixedTD;
    };
    BcTableScrollBehavior.prototype.buildSettingDropdown = function () {
        var html = "\n      <em class=\"bc-icon bc-sm bc-dropdown-toggle\" aria-controls=\"".concat(this.tableId, "DropdownSetting\">settings</em>\n        <div class=\"bc-dropdown-content\" id=\"").concat(this.tableId, "DropdownSetting\">\n         <div class=\"bc-table-setting-header\">\n                <h6>Configurar tabla</h6>\n                <p>Puedes fijar una columna a la izquierda\n                de la tabla y mostrar / ocultar columnas</p>\n                <em class=\"bc-icon bc-xs bc-dropdown-close-button\">error</em>\n         </div>\n         <div class=\"bc-table-setting-body\"></div>\n         <div class=\"bc-table-setting-footer\">\n                <button class=\"bc-button-primary bc-button-small\">Aplicar</button>\n        </div>\n      </div>");
        var dropdown = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        dropdown.classList.add(common_constants_1.BcCommonConstants.BC_DROPDOWN_CLASS, common_constants_1.BcCommonConstants.BC_DROPDOWN_CUSTOM_CLASS, common_constants_1.BcCommonConstants.BC_DROPDOWN_UNDISMISS_CLASS, 'bc-table-dropdown-setting');
        dropdown.innerHTML = html;
        var actionContainer = this.headerTop.querySelector("[class~='".concat(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_CONTAINER_CLASS, "']"));
        actionContainer = this.validateActionContainer(actionContainer);
        var settingBody = dropdown.querySelector("[class=".concat(bc_table_constants_1.BcTableConstansts.TABLE_SETTING_BODY_CLASS, "]"));
        var columnList = this.buildColumnList();
        settingBody.appendChild(columnList);
        if (actionContainer.lastElementChild !== null &&
            !actionContainer.lastElementChild.classList.contains('bc-dropdown')) {
            actionContainer.appendChild(dropdown);
        }
        this.settingDropdownBehavior = this.initDropdown(dropdown, true);
        this.addButtonSettingEvent();
        this.listenDropdownSettingOpen();
    };
    BcTableScrollBehavior.prototype.listenDropdownSettingOpen = function () {
        var _this = this;
        window.addEventListener(bc_abstract_dropdown_constants_1._DROPDOWN_OPENED_EVENT, function (event) {
            if (event.type == 'bcDropdownOpened') {
                _this.verifyFixedColumnsDropdown();
            }
        });
        var thumbtacks = Array.from(this.settingDropdownBehavior.getMySelf().querySelectorAll(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_BUTTON_FIXER)));
        this.verifyThumbtacks(thumbtacks);
    };
    BcTableScrollBehavior.prototype.verifyThumbtacks = function (thumbtacks) {
        var _this = this;
        thumbtacks.forEach(function (item) {
            item.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
                _this.cleandisabledThumbtacks(thumbtacks);
                var input = item.nextElementSibling.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
                input.setAttribute(common_constants_1.BcCommonConstants.DISABLED, null);
                item.parentElement.parentElement.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_CLASS);
            });
        });
    };
    BcTableScrollBehavior.prototype.cleandisabledThumbtacks = function (thumbtacks) {
        thumbtacks.forEach(function (item) {
            var input = item.nextElementSibling.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
            input.removeAttribute(common_constants_1.BcCommonConstants.DISABLED);
        });
    };
    BcTableScrollBehavior.prototype.verifyFixedColumnsDropdown = function () {
        var _this = this;
        var thumbtacks = Array.from(this.settingDropdownBehavior.getMySelf().querySelectorAll(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_BUTTON_FIXER)));
        var fixedColumn = this.mySelf.getElementsByClassName(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS)[0];
        thumbtacks.forEach(function (item) {
            var text = item.parentElement.parentElement.querySelector(common_constants_1.BcCommonConstants.SMALL_TAG).textContent;
            _this.verifyCheckbox(item);
            if (fixedColumn.textContent == text) {
                item.parentElement.parentElement.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_CLASS);
            }
            else {
                item.parentElement.parentElement.classList.remove(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_CLASS);
            }
        });
    };
    BcTableScrollBehavior.prototype.verifyCheckbox = function (element) {
        if (element.parentElement.parentElement.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_CLASS)) {
            var input = element.nextElementSibling.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
            input.setAttribute(common_constants_1.BcCommonConstants.DISABLED, null);
        }
        else {
            var input = element.nextElementSibling.querySelector(common_constants_1.BcCommonConstants.INPUT_TAG);
            input.removeAttribute(common_constants_1.BcCommonConstants.DISABLED);
        }
    };
    BcTableScrollBehavior.prototype.validateActionContainer = function (actionContainer) {
        if (actionContainer !== null) {
            return actionContainer;
        }
        else {
            var rightContainer = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
            rightContainer.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_RIGHT_CONTAINER_CLASS);
            var actionsContainer = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
            actionsContainer.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_CONTAINER_CLASS);
            rightContainer.appendChild(actionsContainer);
            this.headerTop.appendChild(rightContainer);
            return actionsContainer;
        }
    };
    BcTableScrollBehavior.prototype.buildColumnList = function () {
        var _this = this;
        this.getVisibleColumns();
        var element = document.createElement('ul');
        var _loop_1 = function (column) {
            var li = document.createElement('li');
            var idArray = column.id.split('_');
            var fixed = idArray[idArray.length - 1] === String(this_1.currentFixedColumnIndex - 1);
            var html = "\n         <small>".concat(column.name, "</small>\n         <div class=\"bc-table-setting-actions\">\n         <em class=\"bc-icon bc-button-fixer\" id=\"thumbtack_").concat(column.id, "\" tabindex=\"0\">thumbtack</em>\n         <label class=\"bc-container-checkbox\"><input type=\"checkbox\" tabindex=\"0\"\n            id=\"check_").concat(column.id, "\" name=\"name_").concat(column.id, "\" value=\"").concat(column.name, "\"\n            ").concat(this_1.visibleColumnsId.includes(column.id) && 'checked="true"', "\n            ").concat(fixed ? 'disabled' : '', ">\n            <span class=\"bc-checkbox\"></span>\n         </label>\n         </div>\n   ");
            li.innerHTML = html;
            fixed && li.classList.add(bc_table_constants_2_1.BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS);
            var thumbtack = li.querySelector("*[class~=\"bc-button-fixer\"]");
            setTimeout(function () {
                _this.addThumbtackEvent(thumbtack);
            });
            element.appendChild(li);
        };
        var this_1 = this;
        for (var _i = 0, _a = this.columnsData; _i < _a.length; _i++) {
            var column = _a[_i];
            _loop_1(column);
        }
        return element;
    };
    BcTableScrollBehavior.prototype.getVisibleColumns = function () {
        this.visibleColumnsId = [];
        var columns = Array.from(this.mySelf.querySelectorAll(common_constants_1.BcCommonConstants.TH_TAG));
        for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
            var column = columns_1[_i];
            if (!column.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_CHECBOX_CELL_CLASS) &&
                !column.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_COLUMN_CLASS) &&
                !column.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS) &&
                (column.classList.contains(bc_table_constants_2_1.BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS) ||
                    !column.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS))) {
                this.visibleColumnsId.push(column.getAttribute('id'));
            }
        }
    };
    BcTableScrollBehavior.prototype.addThumbtackEvent = function (thumbtack) {
        var _this = this;
        thumbtack.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            var dropdownSetting = _this.settingDropdownBehavior.getMySelf();
            var list = Array.from(dropdownSetting.querySelectorAll('ul li'));
            for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
                var item = list_1[_i];
                var _thumbtack = item.querySelector("*[class~=\"bc-button-fixer\"]");
                _thumbtack.closest('li').classList.remove(bc_table_constants_2_1.BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS);
            }
            var liParent = thumbtack.closest('li');
            liParent.classList.add(bc_table_constants_2_1.BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS);
            liParent.querySelector("input[type=\"".concat(bc_table_constants_1.BcTableConstansts.TABLE_CHECKBOX_SELECTOR, "\"]"))[common_constants_1.BcCommonConstants.CHECKED] =
                true;
            if (liParent.classList.contains(bc_table_constants_2_1.BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS)) {
                _this.newFixedColumnId = thumbtack.getAttribute('id');
            }
        });
    };
    BcTableScrollBehavior.prototype.addButtonSettingEvent = function () {
        var _this = this;
        var dropdownSetting = this.mySelf.querySelector("[id=\"".concat(this.tableId, "DropdownSetting\"]")).parentElement;
        var settingFooter = dropdownSetting.querySelector("[class=".concat(bc_table_constants_1.BcTableConstansts.TABLE_SETTING_FOOTER_CLASS, "]"));
        var acceptButton = settingFooter.querySelector("[class~=".concat(common_constants_1.BcCommonConstants.BTN_PRIMARY_CLASS, "]"));
        acceptButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            event.preventDefault();
            event.stopPropagation();
            for (var _i = 0, _a = _this.columnsVisibiltyStatus; _i < _a.length; _i++) {
                var column = _a[_i];
                if (!column.fixed) {
                    _this.hideShowColumn(column.id, column.visible);
                    _this.hideShowCell(column.id, column.visible);
                }
            }
            _this.settingDropdownBehavior.closeDropdown();
            _this.settingDropdownBehavior.removeScrollClass();
            _this.newFixedColumnId !== '' && _this.updateFixedColumn();
            _this.resetFixedColumn(true);
        });
    };
    BcTableScrollBehavior.prototype.addEventSettingCheckbox = function () {
        var dropdownSetting = this.mySelf.querySelector("[id=\"".concat(this.tableId, "DropdownSetting\"]")).parentElement;
        var settingBody = dropdownSetting.querySelector("[class=".concat(bc_table_constants_1.BcTableConstansts.TABLE_SETTING_BODY_CLASS, "]"));
        var checkboxes = Array.from(settingBody.querySelectorAll("input[type=\"".concat(bc_table_constants_1.BcTableConstansts.TABLE_CHECKBOX_SELECTOR, "\"]")));
        for (var _i = 0, checkboxes_1 = checkboxes; _i < checkboxes_1.length; _i++) {
            var checkbox = checkboxes_1[_i];
            this.setChangeEventCheckbox(checkbox);
        }
    };
    BcTableScrollBehavior.prototype.setChangeEventCheckbox = function (checkbox) {
        var _this = this;
        checkbox.addEventListener(common_constants_1.BcCommonConstants.EVENT_CHANGE, function () {
            _this.prepareColumnList();
        });
    };
    BcTableScrollBehavior.prototype.prepareColumnList = function () {
        var dropdownSetting = this.mySelf.querySelector("[id=\"".concat(this.tableId, "DropdownSetting\"]")).parentElement;
        var settingBody = dropdownSetting.querySelector("[class=".concat(bc_table_constants_1.BcTableConstansts.TABLE_SETTING_BODY_CLASS, "]"));
        var checkboxes = Array.from(settingBody.querySelectorAll("input[type=\"".concat(bc_table_constants_1.BcTableConstansts.TABLE_CHECKBOX_SELECTOR, "\"]")));
        this.columnsVisibiltyStatus = [];
        for (var _i = 0, checkboxes_2 = checkboxes; _i < checkboxes_2.length; _i++) {
            var checkbox = checkboxes_2[_i];
            this.columnsVisibiltyStatus.push({
                id: checkbox.getAttribute('id'),
                visible: checkbox[common_constants_1.BcCommonConstants.CHECKED],
                fixed: checkbox.closest('li').classList.contains(bc_table_constants_2_1.BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS),
            });
        }
    };
    BcTableScrollBehavior.prototype.hideShowColumn = function (id, checked) {
        var columnId = id.indexOf('check_') !== -1 ? id.split('check_')[1] : id;
        for (var _i = 0, _a = this.columns; _i < _a.length; _i++) {
            var column = _a[_i];
            if (column.getAttribute('id') === columnId) {
                if (checked) {
                    column.classList.remove('bc-hidden');
                }
                else {
                    column.classList.add('bc-hidden');
                }
            }
        }
    };
    BcTableScrollBehavior.prototype.hideShowCell = function (columnId, visible) {
        var array = columnId.split('_');
        var index = Number(array[array.length - 1]);
        var increaseSelectionType = 2;
        var increase = this.isSelectionTable ? increaseSelectionType : 1;
        this.rows = Array.from(this.table.querySelectorAll("".concat(bc_table_constants_1.BcTableConstansts.TABLE_ROW_CLASS)));
        for (var i = 1; i < this.rows.length; i++) {
            var row = this.rows[i];
            var child = row.children[index + increase];
            if (!visible) {
                child.classList.add('bc-hidden');
            }
            else if (!child.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS) ||
                !child.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_CELL_CLASS)) {
                child.classList.remove('bc-hidden');
            }
        }
    };
    BcTableScrollBehavior.prototype.updateFixedColumn = function () {
        var columnId = this.newFixedColumnId.split('thumbtack_')[1];
        var idArray = columnId.split('_');
        var columnIndex = idArray[idArray.length - 1];
        var columns = Array.from(this.mySelf.querySelectorAll(common_constants_1.BcCommonConstants.TH_TAG));
        if (columnIndex !== String(this.currentFixedColumnIndex - common_constants_1.COMMON_CONSTANTS_NUMBERS.N1)) {
            for (var _i = 0, columns_2 = columns; _i < columns_2.length; _i++) {
                var column = columns_2[_i];
                column.classList.contains(bc_table_constants_2_1.BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS) &&
                    column.classList.remove(bc_table_constants_2_1.BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS, 'bc-hidden');
                if (columnId === column.getAttribute('id')) {
                    column.classList.add(bc_table_constants_2_1.BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS);
                }
            }
            this.getFixedColumnIndex();
            this.newFixedColumnId = '';
        }
    };
    BcTableScrollBehavior.prototype.resetFixedColumn = function (reBuildContent) {
        for (var _i = 0, _a = this.rows; _i < _a.length; _i++) {
            var row = _a[_i];
            var fixedCell = row.querySelector(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS));
            fixedCell !== null && fixedCell.remove();
            for (var _b = 0, _c = Array.from(row.children); _b < _c.length; _b++) {
                var cell = _c[_b];
                cell.classList.remove(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_CELL_CLASS);
            }
        }
        if (reBuildContent) {
            if (!this.isSelectionTable) {
                this.verifyColumnsHidden();
            }
            this.buildFixedContent();
        }
    };
    BcTableScrollBehavior.prototype.verifyColumnsHidden = function () {
        var rowForValidation = this.rows[1];
        var validatorFixedCell = this.validateFixedCell(rowForValidation);
        for (var i = 0; i < this.columns.length; i++) {
            var column = this.columns[i];
            if (!column.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_COLUMN_CLASS)) {
                var visibleColumn = this.validateContaintHiddenClass(i, rowForValidation.children[i], validatorFixedCell);
                this.addHiddenClass(visibleColumn, column);
            }
        }
    };
    BcTableScrollBehavior.prototype.validateFixedCell = function (rowForValidation) {
        var existFixedCell;
        var firstRow = rowForValidation.children;
        for (var _i = 0, firstRow_1 = firstRow; _i < firstRow_1.length; _i++) {
            var column = firstRow_1[_i];
            if (column.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_LEFT_CLASS)) {
                existFixedCell = true;
                break;
            }
            else {
                existFixedCell = false;
            }
        }
        return existFixedCell ? 0 : -1;
    };
    BcTableScrollBehavior.prototype.validateContaintHiddenClass = function (index, children, validatorFixedCell) {
        if (index > validatorFixedCell && index <= this.columns.length - 1) {
            return children.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS) ? false : true;
        }
    };
    BcTableScrollBehavior.prototype.addHiddenClass = function (visibleColumn, column) {
        if (!visibleColumn && !column.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS)) {
            column.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS);
        }
    };
    BcTableScrollBehavior.prototype.addEventToCloneChk = function (checkboxClone, checkbox, masterCheckbox) {
        var _this = this;
        var inputCheckbox = checkboxClone.querySelector("input[type=\"checkbox\"]");
        inputCheckbox.addEventListener(common_constants_1.BcCommonConstants.EVENT_CHANGE, function (event) {
            event.stopPropagation();
            event.preventDefault();
            checkbox['click']();
            if (event.target !== null) {
                _this.setCheckboxValue(checkbox, event);
            }
            else {
                setTimeout(function () {
                    _this.setCheckboxValue(checkbox, event);
                });
            }
            var firstCellFixed = _this.table.querySelector('.bc-table-fixed-column-left');
            var masterCheckboxClone = firstCellFixed.querySelector("input[type=\"".concat(bc_table_constants_1.BcTableConstansts.TABLE_CHECKBOX_SELECTOR, "\"]"));
            masterCheckboxClone[common_constants_1.BcCommonConstants.CHECKED] = _this.validateAllSelection();
        });
    };
    BcTableScrollBehavior.prototype.setCheckboxValue = function (checkbox, event) {
        checkbox[common_constants_1.BcCommonConstants.CHECKED] = event.target[common_constants_1.BcCommonConstants.CHECKED];
    };
    BcTableScrollBehavior.prototype.resetBodyOverflow = function (dropdownId) {
        if (dropdownId.detail === "".concat(this.tableId, "DropdownSetting")) {
            document.querySelector('body')['style'].overflow = 'auto';
        }
    };
    BcTableScrollBehavior.prototype.undoColumnSelection = function () {
        this.getVisibleColumns();
        var dropdownSetting = this.headerTop.querySelector("*[class~=\"".concat(common_constants_1.BcCommonConstants.BC_DROPDOWN_UNDISMISS_CLASS, "\"]"));
        var list = dropdownSetting !== null ? Array.from(dropdownSetting.querySelectorAll('ul li')) : [];
        for (var _i = 0, list_2 = list; _i < list_2.length; _i++) {
            var item = list_2[_i];
            var checkbox = item.querySelector("input[type=\"".concat(bc_table_constants_1.BcTableConstansts.TABLE_CHECKBOX_SELECTOR, "\"]"));
            var id = checkbox.getAttribute('id').split('check_');
            if (this.visibleColumnsId.includes(id[1])) {
                checkbox[common_constants_1.BcCommonConstants.CHECKED] = true;
            }
            else {
                checkbox[common_constants_1.BcCommonConstants.CHECKED] = false;
            }
        }
        dropdownSetting !== null && this.undoFixedColumn();
    };
    BcTableScrollBehavior.prototype.undoFixedColumn = function () {
        var dropdownSetting = this.mySelf.querySelector(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_DROPDOWN_SETTINGS_CLASS));
        var thumbtacks = Array.from(dropdownSetting.querySelectorAll(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_BUTTON_FIXER)));
        for (var _i = 0, thumbtacks_1 = thumbtacks; _i < thumbtacks_1.length; _i++) {
            var thumbtack = thumbtacks_1[_i];
            var idArray = thumbtack.getAttribute('id').split('_');
            var isFixed = idArray[idArray.length - 1] === String(this.currentFixedColumnIndex);
            if (isFixed) {
                thumbtack.closest('li').classList.add(bc_table_constants_2_1.BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS);
            }
            else {
                thumbtack.closest('li').classList.remove(bc_table_constants_2_1.BcTableConstansts2.TABLE_FIXED_COLUMN_CLASS);
            }
        }
    };
    BcTableScrollBehavior.prototype.hiddeCellByColumn = function () {
        for (var _i = 0, _a = this.columns; _i < _a.length; _i++) {
            var comlun = _a[_i];
            if (comlun.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS)) {
                this.hideShowCell(comlun.getAttribute('id'), false);
            }
        }
    };
    BcTableScrollBehavior.prototype.setActionColumnListener = function () {
        var _this = this;
        this.actionCells = Array.from(this.mySelf.querySelectorAll("td[class*=\"".concat(bc_table_constants_1.BcTableConstansts.TABLE_ACTION_CELL_CLASS, "\"]")));
        var _loop_2 = function (cell) {
            cell.addEventListener('keydown', function (event) {
                if (event.code == common_constants_1.BcCommonConstants.KEY_EVENT_SPACE || event.key == common_constants_1.BcCommonConstants.KEY_EVENT_ENTER) {
                    if (!_this.isCellActionInline) {
                        var newCell = cell.childNodes[0].childNodes[0];
                        newCell.click();
                    }
                    else {
                        var newCell = cell.childNodes[0];
                        newCell.click();
                    }
                }
            });
        };
        for (var _i = 0, _a = this.actionCells; _i < _a.length; _i++) {
            var cell = _a[_i];
            _loop_2(cell);
        }
    };
    BcTableScrollBehavior.prototype.setColumnId = function () {
        var visibleColumnIndex = 0;
        for (var _i = 0, _a = this.columns; _i < _a.length; _i++) {
            var column = _a[_i];
            if (!column.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS)) {
                column.setAttribute('id', "".concat(this.tableId, "_column_").concat(visibleColumnIndex));
                visibleColumnIndex++;
            }
        }
    };
    BcTableScrollBehavior.prototype.copyFixedCellClasses = function (fixedCell, newFixedCell) {
        var _a;
        var fixedCellClasses = Array.from(fixedCell.classList);
        var filteredClasses = fixedCellClasses.filter(function (cls) { return cls !== bc_table_constants_1.BcTableConstansts.TABLE_FIXED_CELL_CLASS && cls !== bc_table_constants_1.BcTableConstansts.TABLE_FIXED_COLUMN_CLASS; });
        (_a = newFixedCell.classList).add.apply(_a, filteredClasses);
        newFixedCell.innerHTML = fixedCell.innerHTML;
    };
    BcTableScrollBehavior.prototype.handleSelectionTable = function (row, newFixedCell, masterCheckbox, fixedCell) {
        var checkboxCell = row.querySelector(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_CHECBOX_CELL_CLASS));
        var checkbox = checkboxCell.querySelector(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_CHECBOX_CONTAINER_CLASS));
        var checkboxClone = checkbox.cloneNode(true);
        var chk = checkboxClone.querySelector("input[type=\"".concat(bc_table_constants_1.BcTableConstansts.TABLE_CHECKBOX_SELECTOR, "\"]"));
        chk[common_constants_1.BcCommonConstants.CHECKED] = false;
        newFixedCell.appendChild(checkboxClone);
        var contentWrapper = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        contentWrapper.style.width = bc_table_constants_1.BcTableConstansts.BC_CELL_WIDTH;
        Array.from(fixedCell.childNodes).forEach(function (child) {
            contentWrapper.appendChild(child.cloneNode(true));
        });
        newFixedCell.appendChild(contentWrapper);
        checkboxCell.classList.add(bc_table_constants_1.BcTableConstansts.TABLE_HIDDEN_CLASS);
        if (!checkbox.classList.contains(bc_table_constants_1.BcTableConstansts.TABLE_MASTER_CHECKBOX_CLASS)) {
            this.addEventToCloneChk(checkboxClone, checkbox, masterCheckbox);
        }
    };
    BcTableScrollBehavior.prototype.copyCellContent = function (fixedCell, newFixedCell, isFirstRow) {
        if (isFirstRow) {
            var title = fixedCell.textContent.replace(/arrow-up|arrow-down/g, '').trim();
            newFixedCell.append(title);
            var sortIcon = fixedCell.querySelector(".".concat(bc_table_constants_1.BcTableConstansts.TABLE_SORT_ICON_CLASS));
            if (sortIcon) {
                var icon = fixedCell.textContent.includes(common_constants_1.BcCommonConstants.BC_ARROW_UP_ICON)
                    ? common_constants_1.BcCommonConstants.BC_ARROW_UP_ICON
                    : common_constants_1.BcCommonConstants.BC_ARROW_DOWN_ICON;
                this.asc = icon === common_constants_1.BcCommonConstants.BC_ARROW_UP_ICON ? false : true;
                this.addSortIcon(newFixedCell);
            }
        }
        else {
            newFixedCell.append(fixedCell.textContent);
        }
    };
    return BcTableScrollBehavior;
}(bc_table_base_behavior_1.BcTableBaseBehavior));
exports.BcTableScrollBehavior = BcTableScrollBehavior;
